import script from "./imageResizer.vue?vue&type=script&setup=true&lang=js"
export * from "./imageResizer.vue?vue&type=script&setup=true&lang=js"

import "./imageResizer.vue?vue&type=style&index=0&id=acb85d6e&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb85d6e"]])

export default __exports__